export type DiagnosticProfileName =
  | 'default'
  | 'debug'
  | 'deepDebug'
  | 'disabled';

export enum DiagnosticEventType {
  ROUTE = 'ROUTE',
  API = 'API',
  ERROR = 'ERROR',
  USER_ACTION = 'USER_ACTION',
}

/**
 * Semantic tier label. Surfaces in the UI ("Diagnosztika szintje")
 * and is documented for the support engineer; the actual collection
 * behavior is driven by `apiPayload` (see EAS-2043).
 *
 * - `minimal`: only event metadata (URL, status, traceId, …)
 * - `standard`: + request body excerpt
 * - `verbose`: + response body excerpt + request/response headers.
 *   `verbose` carries sensitive data risk and is enforced via the
 *   `requiredRole` runtime guard in `diagnostic-profiles.const.ts`.
 */
export type PayloadDepth = 'minimal' | 'standard' | 'verbose';

/**
 * Granular per-API-event capture config. Separate from `payloadDepth`
 * so a later UI (EAS-2047 / EAS-2048) can override the static values
 * without changing the semantic tier name. Fields are optional: an
 * absent `requestBodyMaxChars` means "do not capture request body";
 * an absent `responseBodyMaxChars` means "do not capture response
 * body"; `captureHeaders` defaults to false.
 */
export interface ApiPayloadConfig {
  requestBodyMaxChars?: number;
  responseBodyMaxChars?: number;
  captureHeaders?: boolean;
}

export interface DiagnosticProfile {
  name: DiagnosticProfileName;
  maxEvents: number;
  maxWindowMs: number;
  eventTypes: readonly DiagnosticEventType[];
  requiredRole?: string;
  payloadDepth: PayloadDepth;
  apiPayload?: ApiPayloadConfig;
}
